<form [formGroup]="indirizzoForm">
  <div fxLayout="column" fxLayoutGap="20px">
    <div *ngIf="datiAnagrafici.isCfStraniero && datiAnagrafici.datiAnaForm.get('tipoCliente')?.value != 0">
      <mat-checkbox formControlName="indirizzoEstero">Indirizzo estero</mat-checkbox>
    </div>

    <ng-container *ngIf="(datiAnagrafici.datiAnaForm.get('tipoCliente')?.value == '1' || dataService.prodotto?.tipo_utenza == 'DOM') && indirizzoForm.get('indirizzoEstero')?.value; else autocomplete">
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field>
          <!-- <bw-autocomplete [required]="setRequired(indirizzoForm.get('toponimo'))" [source]="toponimi$" valueMember="cod_toponimo" displayMember="des_toponimo" formControlName="toponimo"
                        placeholder="Toponimo (Via, Piazza ...)"></bw-autocomplete> -->
          <input [required]="setRequired(indirizzoForm.get('toponimo'))" matInput placeholder="Toponimo" formControlName="toponimo" oninput="this.value = this.value.toUpperCase()">
          <mat-error *ngIf="indirizzoForm.get('toponimo')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('indirizzo'))" matInput placeholder="Indirizzo" formControlName="indirizzo" oninput="this.value = this.value.toUpperCase()">
          <mat-error *ngIf="indirizzoForm.get('indirizzo')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error *ngIf="indirizzoForm.get('indirizzo')!.hasError('pattern')">
            <strong>Non compilare con caratteri speciali</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('civico'))" matInput placeholder="Civico" formControlName="civico">
          <mat-error *ngIf="indirizzoForm.get('civico')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field fxFlex="30">
          <input [required]="setRequired(indirizzoForm.get('comune'))" matInput placeholder="Comune" formControlName="comune" oninput="this.value = this.value.toUpperCase()">
          <mat-error *ngIf="indirizzoForm.get('comune')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('cap'))" matInput placeholder="Cap" formControlName="cap">
          <mat-error *ngIf="indirizzoForm.get('cap')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('nazione'))" matInput placeholder="Nazione" formControlName="nazione" oninput="this.value = this.value.toUpperCase()">
          <mat-error *ngIf="indirizzoForm.get('nazione')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <ng-container *ngIf="options == 'presso'">
          <mat-form-field>
            <input matInput placeholder="C/O" formControlName="presso">
          </mat-form-field>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #autocomplete>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field>
          <bw-autocomplete [required]="setRequired(indirizzoForm.get('toponimo'))" [source]="toponimi$" valueMember="cod_toponimo" displayMember="des_toponimo" formControlName="toponimo"
            placeholder="Toponimo (Via, Piazza ...)"></bw-autocomplete>
          <!-- <input [required]="setRequired('toponimo')" matInput placeholder="Toponimo" formControlName="toponimo"> -->
          <mat-error *ngIf="indirizzoForm.get('toponimo')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('indirizzo'))" matInput placeholder="Indirizzo" formControlName="indirizzo">
          <mat-error *ngIf="indirizzoForm.get('indirizzo')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error *ngIf="indirizzoForm.get('indirizzo')!.hasError('pattern')">
            <strong>Non compilare con caratteri speciali</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('civico'))" matInput placeholder="Civico" formControlName="civico">
          <mat-error *ngIf="indirizzoForm.get('civico')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field fxFlex="30">
          <bw-autocomplete [required]="setRequired(indirizzoForm.get('comune'))" [source]="comuni$" valueMember="id_comune" displayMember="comune" [secondLineMember]="secondLineFn"
            formControlName="comune" placeholder="Comune" (optionSelectedEvent)="comuneSelected($event)">
          </bw-autocomplete>
          <!-- <input [required]="setRequired('comune')" matInput placeholder="Comune" formControlName="comune"> -->
          <mat-error *ngIf="indirizzoForm.get('comune')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(indirizzoForm.get('cap'))" matInput placeholder="Cap" formControlName="cap">
          <mat-error *ngIf="indirizzoForm.get('cap')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <bw-autocomplete [required]="setRequired(indirizzoForm.get('provincia'))" [source]="province$" valueMember="id_provincia" displayMember="provincia" formControlName="provincia"
            placeholder="Provincia"></bw-autocomplete>
          <!-- <input [required]="setRequired('provincia')" matInput placeholder="Provincia" formControlName="provincia"> -->
          <mat-error *ngIf="indirizzoForm.get('provincia')!.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <ng-container *ngIf="options == 'presso'">
          <mat-form-field>
            <input matInput placeholder="C/O" formControlName="presso">
          </mat-form-field>
        </ng-container>
      </div>
    </ng-template>

  </div>
</form>